export default __webpack_public_path__ + "static/media/Quote.894bbe13.svg";